<span *ngIf="noticeCountService.noticeCount[type]>0" class="badge p-badge-success">{{noticeCountService.noticeCount[type]}}</span>
